/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FatturaRicevutaDtoFromJSON, FatturaRicevutaDtoToJSON, } from './FatturaRicevutaDto';
/**
 * Check if a given object implements the FatturaRicevutaPagedDto interface.
 */
export function instanceOfFatturaRicevutaPagedDto(value) {
    return true;
}
export function FatturaRicevutaPagedDtoFromJSON(json) {
    return FatturaRicevutaPagedDtoFromJSONTyped(json, false);
}
export function FatturaRicevutaPagedDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'content': json['content'] == null ? undefined : (json['content'].map(FatturaRicevutaDtoFromJSON)),
        'size': json['size'] == null ? undefined : json['size'],
        'page': json['page'] == null ? undefined : json['page'],
        'totalElements': json['totalElements'] == null ? undefined : json['totalElements'],
        'totalPages': json['totalPages'] == null ? undefined : json['totalPages'],
    };
}
export function FatturaRicevutaPagedDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'content': value['content'] == null ? undefined : (value['content'].map(FatturaRicevutaDtoToJSON)),
        'size': value['size'],
        'page': value['page'],
        'totalElements': value['totalElements'],
        'totalPages': value['totalPages'],
    };
}
